import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
// Hospitality Landing Theme - fully individual for this landing page
export const theme = createTheme({
    typography: {
        // Rubik font family from Slim template
        fontFamily: '"Rubik", "Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
        button: {
            textTransform: 'none',
        },
        h1: {
            fontSize: '34px',
            fontWeight: 700,
            lineHeight: 1.25,
            color: palette.text.primary,
        },
        h2: {
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: 1.25,
            color: palette.text.primary,
        },
        h3: {
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: 1.375,
            color: palette.text.primary,
        },
        h4: {
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: 1.375,
            color: palette.text.primary,
        },
        h5: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: 1.5,
            color: palette.text.primary,
        },
        h6: {
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: 1.5,
            color: palette.text.primary,
        },
        subtitle1: {
            fontSize: '16px',
            fontWeight: 500,
            color: palette.text.primary,
        },
        subtitle2: {
            fontSize: '16px',
            fontWeight: 400,
            color: palette.text.secondary,
        },
        body1: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            color: palette.text.primary,
        },
        body2: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            color: palette.text.secondary,
        },
        caption: {
            fontSize: '12px',
            fontWeight: 400,
            color: palette.text.secondary,
        },
    },
    palette: {
        mode: 'light',
        primary: palette.primary,
        secondary: palette.secondary,
        success: palette.success,
        warning: palette.warning,
        error: palette.error,
        text: {
            primary: palette.text.primary,
            secondary: palette.text.secondary,
        },
        background: palette.background,
        divider: palette.border,
    },
    spacing: 4, // Match scoring app spacing (4px base unit)
    shape: {
        borderRadius: 2,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box',
                },
                body: {
                    scrollBehavior: 'smooth',
                    backgroundColor: palette.background.default,
                },
                '#root': {
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                },
                a: {
                    textDecoration: 'none',
                    color: 'inherit',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                color: 'secondary',
            },
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                    padding: '10px 24px',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    textTransform: 'none',
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 4px 8px rgba(31, 95, 216, 0.25)',
                    },
                },
                outlined: {
                    borderWidth: '1px',
                    '&:hover': {
                        color: palette.secondary.contrastText,
                        borderWidth: '1px',
                        borderColor: palette.secondary.dark,
                        backgroundColor: 'rgba(31, 95, 216, 0.04)',
                    },
                },
            },
        },
        MuiCard: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                    border: `1px solid ${palette.border}`,
                    boxShadow: '0px 15px 10px -15px rgba(0, 0, 0, 0.05)',
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '6px',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: palette.primary.main,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: palette.primary.main,
                        },
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    boxShadow: 'none',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: palette.border,
                },
            },
        },
    },
});
